import { IOmniaHttpService, IOmniaSession } from "../../types"
import { checkPassword, getPasswordError, msgPasswordRule } from "../../user/password/password"
import { defineDirective } from "../../utils/angular"

/** @internal */
export class ResetPwdCtrl2 {

    static create(): ng.IDirective {

        return defineDirective(ResetPwdCtrl2, "shared/main/resetpwd/reset2.html");

    }

    passwordRuleLabel = msgPasswordRule

    form: ng.IFormController
    showValidationErrors = false
    sent = false

    password: string
    password2: string

    static $inject = ["OmniaSession", "OmniaHttpService"]

    constructor(
        private session: IOmniaSession,
        private ohttp: IOmniaHttpService,
        public readonly username = session.currentUser.Email) {

    }

    checkPassword() {
        const { password, password2 } = this
        const e = checkPassword(password, password2)
        return getPasswordError(e)
    }

    canCommit() {
        return !(this.checkPassword() || this.form.$invalid)
    }

    commit() {

        if (!this.canCommit()) {
            this.showValidationErrors = true
            return
        }

        this.showValidationErrors = false

        const { password } = this
        const url = "/api/user/v1/password/change"

        this.ohttp.post(url, { password }).then(() => {
            this.sent = true
            window.setTimeout(() => {
                this.cancel()
            }, 1500)
        })

    }

    cancel() {
        this.session.logout()
    }

}

